import { Navigate, useRoutes } from 'react-router-dom';
import { lazy } from 'react';
import { useAppSelector } from '../redux/hooks';

const Login = lazy(() => import('../views/login/Login'));
const Tenancy = lazy(() => import('../views/tenancy/Tenancy'));
const Dashboard = lazy(() => import('../views/dashboard/Dashboard'));
const RoomRundown = lazy(() => import('../views/room/RoomRundown'));
const Analyze = lazy(() => import('../views/analyze/Analyze'));
const RoomInfo = lazy(() => import('../views/room/RoomInfo'));
const RoomGraph = lazy(() => import('../views/room/RoomGraph'));

function AppRoutes() {
	const loggedIn = useAppSelector((state) => state.authentication.loggedIn);
	const tenancyStatus = useAppSelector((state) => state.authentication.tenancyStatus);

	return useRoutes([
		{
			path: '/login',
			element: loggedIn ? (
				tenancyStatus ? (
					<Navigate replace to="/dashboard" />
				) : (
					<Navigate replace to="/tenancy" />
				)
			) : (
				<Login />
			),
		},
		{
			path: '/tenancy',
			element: loggedIn ? (
				!tenancyStatus ? (
					<Tenancy />
				) : (
					<Navigate replace to="/dashboard" />
				)
			) : (
				<Navigate replace to="/login" />
			),
		},
		{
			path: '/analyze',
			element: loggedIn ? (
				tenancyStatus ? (
					<Analyze />
				) : (
					<Navigate replace to="/tenancy" />
				)
			) : (
				<Navigate replace to="/login" />
			),
		},
		{
			path: '/dashboard',
			element: loggedIn ? (
				tenancyStatus ? (
					<Dashboard />
				) : (
					<Navigate replace to="/tenancy" />
				)
			) : (
				<Navigate replace to="/login" />
			),
		},
		{
			path: '/room',
			element: loggedIn ? (
				tenancyStatus ? (
					<RoomRundown />
				) : (
					<Navigate replace to="/tenancy" />
				)
			) : (
				<Navigate replace to="/login" />
			),
			children: [
				{
					path: ':roomId',
					index: true,
					element: loggedIn ? (
						tenancyStatus ? (
							<RoomInfo />
						) : (
							<Navigate replace to="/tenancy" />
						)
					) : (
						<Navigate replace to="/login" />
					),
				},
				{
					path: ':roomId/graph',
					element: loggedIn ? (
						tenancyStatus ? (
							<RoomGraph />
						) : (
							<Navigate replace to="/tenancy" />
						)
					) : (
						<Navigate replace to="/login" />
					),
				},
			],
		},
		{ path: '*', element: <Navigate to="/dashboard" replace /> },
	]);
}

export default AppRoutes;
